import { AddWidgetCard } from "@/components/dashboard/add-widget-card";
import { WidgetFrame } from "@/components/dashboard/widget-frame";
import { WIDGET_REGISTRY, type WidgetContext } from "@/components/dashboard/widget-registry";
import { addableWidgets, type WidgetId } from "@/lib/dashboard-widgets";

type Props = {
  layout: readonly WidgetId[];
  ctx: WidgetContext;
  onMove: (id: WidgetId, delta: -1 | 1) => void;
  onRemove: (id: WidgetId) => void;
  onAdd: (id: WidgetId) => void;
};

/**
 * The customisable tail (positions 5–8, POS2-877): the user's layout rendered
 * through the registry, each widget in a control frame, closed by the
 * add-widget card. The fixed core above never goes through here.
 */
export function WidgetTail({ layout, ctx, onMove, onRemove, onAdd }: Props) {
  return (
    <>
      {layout.map((id, i) => {
        const widget = WIDGET_REGISTRY[id];
        return (
          <WidgetFrame
            key={id}
            title={ctx.t(widget.titleKey)}
            canMoveUp={i > 0}
            canMoveDown={i < layout.length - 1}
            onMoveUp={() => onMove(id, -1)}
            onMoveDown={() => onMove(id, 1)}
            onRemove={() => onRemove(id)}
          >
            {widget.render(ctx)}
          </WidgetFrame>
        );
      })}
      <AddWidgetCard
        options={addableWidgets(layout).map((id) => ({
          id,
          title: ctx.t(WIDGET_REGISTRY[id].titleKey),
        }))}
        onAdd={onAdd}
      />
    </>
  );
}
